"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeProductFromCart = exports.continueToCart = exports.addProductToCart = void 0;
var _domainServices = require("@site/domain-services");
const addProductToCart = async ({
  sapiPostData,
  plid,
  basketId,
  apiKey,
  env,
  market,
  resellerBaseOverride,
  traceId = ''
}) => {
  const {
    sapiCartPackages
  } = new _domainServices.DomainServices({
    apiKey,
    plid,
    env,
    market,
    resellerBaseOverride
  });
  const options = {
    method: 'POST',
    body: JSON.stringify(sapiPostData),
    headers: {
      'Content-Type': 'application/json',
      ...(traceId && {
        traceparent: traceId
      })
    }
  };
  const extraParams = basketId ? {
    basketId
  } : {};
  return await sapiCartPackages({
    packageId: '',
    options,
    extraParams
  });
};
exports.addProductToCart = addProductToCart;
const removeProductFromCart = async ({
  sapiPackages = [],
  plid,
  apiKey,
  env,
  market,
  resellerBaseOverride,
  traceId = ''
}) => {
  const {
    sapiCartDomainsPromise,
    sapiCartPackagesPromise
  } = new _domainServices.DomainServices({
    apiKey,
    plid,
    env,
    market,
    resellerBaseOverride
  });
  return await Promise.all(sapiPackages.map(async ({
    domains,
    domain
  }) => {
    const options = {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        ...(traceId && {
          traceparent: traceId
        })
      }
    };
    const packageIsBundle = Boolean(domains && !domain);
    if (packageIsBundle) {
      // Bundle Type Package.
      return await sapiCartPackagesPromise({
        packageId: 'domain-bundle',
        options
      }).then(resolve => (0, _domainServices.commonResolve)(resolve)).catch(error => error);
    }
    // Non Bundle Type Packages
    return await sapiCartDomainsPromise({
      domain: domain?.name,
      options
    }).then(resolve => (0, _domainServices.commonResolve)(resolve)).catch(error => error);
  }));
};
exports.removeProductFromCart = removeProductFromCart;
const continueToCart = () => {
  // TODO
};
exports.continueToCart = continueToCart;